import { clientApp } from './index';

export const getDebugMode = () => clientApp.get(`/ui/user/debug`);

export const putDebugMode = (data = []) => clientApp.put(`/ui/user/debug`, data);
